/* ============================================================
   BIBERKO — homepage interakcije
   Sve je vezano preko delegacije na document, pa radi i posle
   Theme Editor re-rendera sekcija (shopify:section:load).
   ============================================================ */
(function () {
  'use strict';
  if (window.__biberkoInit) return;
  window.__biberkoInit = true;

  var doc = document;

  /* ---------- helpers ---------- */
  function closeMega() {
    doc.querySelectorAll('[data-bib-mega]').forEach(function (el) {
      el.hidden = true;
      var btn = doc.querySelector('[data-bib-mega-toggle="' + el.dataset.bibMega + '"]');
      if (btn) btn.setAttribute('aria-expanded', 'false');
    });
  }

  function closeDrawer() {
    doc.querySelectorAll('[data-bib-drawer]').forEach(function (el) {
      el.classList.remove('is-open');
    });
    doc.documentElement.style.overflow = '';
  }

  function setCartCount(count) {
    doc.querySelectorAll('[data-bib-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = !count;
    });
  }

  /* ---------- click delegation ---------- */
  doc.addEventListener('click', function (event) {
    var megaToggle = event.target.closest('[data-bib-mega-toggle]');
    if (megaToggle) {
      event.preventDefault();
      var id = megaToggle.getAttribute('data-bib-mega-toggle');
      var panel = doc.querySelector('[data-bib-mega="' + id + '"]');
      if (!panel) return;
      var willOpen = panel.hidden;
      closeMega();
      panel.hidden = !willOpen;
      megaToggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      return;
    }

    var drawerOpen = event.target.closest('[data-bib-drawer-open]');
    if (drawerOpen) {
      event.preventDefault();
      var target = doc.querySelector('[data-bib-drawer="' + drawerOpen.getAttribute('data-bib-drawer-open') + '"]');
      if (target) {
        target.classList.add('is-open');
        doc.documentElement.style.overflow = 'hidden';
        var focusable = target.querySelector('a, button');
        if (focusable) focusable.focus();
      }
      return;
    }

    if (event.target.closest('[data-bib-drawer-close]')) {
      event.preventDefault();
      closeDrawer();
      return;
    }

    if (!event.target.closest('[data-bib-mega]')) closeMega();
  });

  doc.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      closeMega();
      closeDrawer();
    }
  });

  /* ---------- quick add ---------- */
  doc.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-bib-quick-add]');
    if (!form) return;
    if (!window.fetch) return; // graceful fallback: normalan POST na /cart/add

    event.preventDefault();
    var button = form.querySelector('button[type="submit"]');
    if (button) button.classList.add('is-loading');

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    fetch(form.getAttribute('action') + '.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(form)
    })
      .then(function (response) {
        if (!response.ok) throw new Error('add-failed');
        return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } });
      })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        setCartCount(cart.item_count);
        doc.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        doc.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { cart: cart } }));
      })
      .catch(function () {
        form.submit(); // ako fetch pukne, radi klasičan submit
      })
      .finally(function () {
        if (button) button.classList.remove('is-loading');
      });
  });

  /* ---------- sinhronizacija brojača korpe ---------- */
  function syncCart() {
    if (!window.fetch || !doc.querySelector('[data-bib-cart-count]')) return;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        setCartCount(cart.item_count);
      })
      .catch(function () {});
  }

  if (doc.readyState === 'loading') {
    doc.addEventListener('DOMContentLoaded', syncCart);
  } else {
    syncCart();
  }

  doc.addEventListener('shopify:section:load', function () {
    closeMega();
    closeDrawer();
    syncCart();
  });
})();
